import type {
  DocumentUpdatedSubscription,
  DocumentUpdatedSubscriptionVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const DOCUMENT_UPDATED: TypedDocumentNode<
  DocumentUpdatedSubscription,
  DocumentUpdatedSubscriptionVariables
> = gql`
  subscription DocumentUpdated($documentId: String!) {
    documentUpdated(documentId: $documentId) {
      documentId
      ownerUserId
      updatedAt
    }
  }
`;
